<template>
  <div>
    <div v-if="image" class="avatar">
      <div class="item">
        <img :src="image" :class="small ? 'small' : ''" class="rounded" />
      </div>
    </div>
    <div v-else class="avatar bg rounded-circle">
      <img src="../../assets/images/image_outlined.svg" class="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxImage",
  props: ["image", "size", "small"],
  computed: {
    src() {
      const images = require.context("../../assets/images/", false, /\.jpg$/);
      return images("./" + this.image);
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  min-width: 100%;
  height: 40vh;
  object-fit: cover;
}

.avatar {
  // overflow: hidden;
  //   border-radius: 50%;
  .item {
    display: flex;
  }
  @media (max-width: 756px) {
    .small {
      width: 25px !important;
      height: 25px !important;
    }
  }
}


@media (max-width: 1440px) {
  img {
    height: 30vh;
  }
}

@media (max-width: 320px) {
  img {
    height: 25vh;
  }
}
</style>
